import { render, staticRenderFns } from "./RelatorioLogProfissional.vue?vue&type=template&id=6e3ebbf3"
import script from "./RelatorioLogProfissional.vue?vue&type=script&lang=js"
export * from "./RelatorioLogProfissional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports